var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, InternalMessageBusChannels, action } from "../ExternalDependencies";
export class Retriever {
    constructor(realityCheckConnection, internalMessageBus) {
        this.isShowEnabled = true;
        this.isShowEnabledMessageHandler = (message) => {
            this.isShowEnabled = message.data[0];
        };
        this.realityCheckConnection = realityCheckConnection;
        this.internalMessageBus = internalMessageBus;
    }
    activate() {
        this.internalMessageBus.on(InternalMessageBusChannels.legacy.userInfo.onLogin, this.onLogin);
        this.internalMessageBus.on(InternalMessageBusChannels.legacy.userInfo.onLogout, this.onLogout);
        this.internalMessageBus.on(InternalMessageBusChannels.realityCheck.isShowEnabled, this.isShowEnabledMessageHandler);
    }
    deactivate() {
        this.internalMessageBus.off(InternalMessageBusChannels.legacy.userInfo.onLogin, this.onLogin);
        this.internalMessageBus.off(InternalMessageBusChannels.legacy.userInfo.onLogout, this.onLogout);
        this.internalMessageBus.off(InternalMessageBusChannels.realityCheck.isShowEnabled, this.isShowEnabledMessageHandler);
    }
    getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.realityCheckConnection.getSettings();
        });
    }
    saveSettings(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.realityCheckConnection.saveSettings(settings);
        });
    }
    getWageringInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.realityCheckConnection.getWageringInformation();
        });
    }
    getShowState() {
        const showState = localStorage.getItem("RealityCheckShowState");
        if (!showState) {
            return undefined;
        }
        const parsedShowState = JSON.parse(showState);
        if (parsedShowState.nextShowDate) {
            parsedShowState.nextShowDate = new Date(parsedShowState.nextShowDate);
        }
        return parsedShowState;
    }
    saveShowState(showState) {
        localStorage.setItem("RealityCheckShowState", JSON.stringify(showState));
    }
    removeShowState() {
        localStorage.removeItem("RealityCheckShowState");
    }
    onLogin(message) {
        this.userInfo = message.data[0];
    }
    onLogout() {
        this.userInfo = undefined;
    }
    onShow() {
        this.internalMessageBus.emit(InternalMessageBusChannels.realityCheck.onShow);
    }
    onClose() {
        this.internalMessageBus.emit(InternalMessageBusChannels.realityCheck.onClose);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "userInfo", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Retriever.prototype, "isShowEnabled", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "onLogin", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "onLogout", null);
//# sourceMappingURL=Retriever.js.map